export default "__VITE_ASSET__CB1P8nrN__"